/* @flow */

import React, { useState } from 'react';
import { Section, TitleH2 } from '../styles';
import {
	QuestionsWrapper,
	QuestionItem,
	QuestionText,
	QuestionDescription,
	DropDownElem,
	DropDownIcon,
} from './styles';
import { Container } from '../../../components/Layout/styles';
import { dropdownIconSmall } from '../../../components/Icons';

type TQuestionsItem = {
	text: string,
	description: string,
	id: string,
};
const QuestionsItem = ({ text, description, id }: TQuestionsItem) => {
	const [showDescription, setShowDescription] = useState(false);
	return (
		<QuestionItem
			role="button"
			type="button"
			onClick={() => {
				setShowDescription(!showDescription);
			}}
			aria-expanded={showDescription}
			aria-controls={`description-${id}`}
		>
			<QuestionText role="heading" aria-level={3}>
				{text}
			</QuestionText>

			<DropDownElem>
				<DropDownIcon viewBox="0 0 16 16" reverse={showDescription}>
					{dropdownIconSmall}
				</DropDownIcon>
			</DropDownElem>
			<QuestionDescription id={`description-${id}`} isActive={showDescription}>
				{showDescription && description}
			</QuestionDescription>
		</QuestionItem>
	);
};
type TProps = {
	sectionType?: string,
};

const Questions = (props: TProps) => {
	const { sectionType } = props;

	const QUESTIONS_LIST = [
		{
			id: 0,
			text: 'Чем Living.ru отличается от агентства недвижимости?',
			description:
				'В Living вашу задачу решает не один человек, а целая команда. Каждый отвечает за свой профильный этап: менеджеры подбора ищут квартиру, юрист проверяет документы, ипотечный специалист помогает выбрать программу и подать заявку, а личный менеджер курирует сделку.\nА еще мы работаем по фиксированной цене, которая не зависит от стоимости выбранной квартиры. Это гарантирует честный и беспристрастный подход в выборе объектов.',
		},
		{
			id: 1,
			text: 'Чем безопасная сделка от Living.ru отличается от банковской?',
			description:
				'Все просто: основная задача банковской проверки — снизить собственные риски, основная задача нашей проверки — снизить ВАШИ риски. Наша проверка включает до 26 пунктов. В рамках услуги мы проверяем квартиру, продавца и документы.',
		},
		{
			id: 2,
			text: 'Почему работать с Living.ru безопасно?',
			description:
				'Перед началом работы мы заключаем договор, в котором четко прописаны ваши гарантии. Главная гарантия: если вы передумаете, мы вернем вам всю сумму, выплаченную к моменту прекращения работы.',
		},
		{
			id: 3,
			text: 'А вдруг вы не сможете оказать мне услугу?',
			description:
				'Такая ситуация практически невозможна, но если вдруг по каким-либо причинам мы поймем, что не можем помочь вам, то вернем всю сумму, выплаченную к этому моменту.',
		},
		{
			id: 4,
			text: 'Какие гарантии, что сделка пройдет хорошо?',
			description:
				'На этапе проверки мы сделаем все, чтобы выявить возможные риски и избежать их в будущем. Для этого мы проверяем все документы и информацию по продавцу. Проверку осуществляют квалифицированные специалисты.',
		},
	];
	return (
		<Section id="SectionQuestions" $type={sectionType}>
			<Container>
				<TitleH2 isCenter>Часто задаваемые вопросы</TitleH2>
				<QuestionsWrapper>
					{QUESTIONS_LIST.map((item) => (
						<QuestionsItem key={item.id} id={item.id} text={item.text} description={item.description} />
					))}
				</QuestionsWrapper>
			</Container>
		</Section>
	);
};

Questions.defaultProps = { sectionType: 'questions' };

export default Questions;
